<template>
    <v-container>
        <v-overlay :value="isLoading" absolute>
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================================================================================================ -->
        <v-row>
            <v-col>
                <h2 class="my-2">サイト一覧</h2>
            </v-col>
        </v-row>
        <!-- ============================================================================================================================ -->
        <v-row>
            <v-col cols="12" md="6" lg="4" v-for="obj of dbSites" :key="obj.id">
                <v-card>
                    <v-toolbar color="indigo" dark>
                        <v-toolbar-title class="font-weight-bold">{{ obj.name }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <h4>都道府県名：{{ obj.pref }}</h4>
                        <h4>市町村名：{{ obj.city }}</h4>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn small color="success" @click="openDlgClick(obj.id)"><h3>編集</h3></v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="showEditDlg" fullscreen transition="dialog-bottom-transition">
            <v-card color="grey lighten-4">
                <v-toolbar color="indigo" dark>
                    <v-toolbar-title>{{ dlgSite.name }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showEditDlg = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text class="mt-10">
                    <v-row>
                        <v-col>
                            <v-sheet class="pa-3" elevation="2">
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field label="サイト名" v-model="dlgSite.name" outlined dense></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-select label="都道府県" v-model="dlgSite.pref_id" :items="optPref" outlined dense hide-details></v-select>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field label="市町村" v-model="dlgSite.city" outlined dense></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-sheet>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- --------------------- -->
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col class="text-center pa-0">
                            <v-btn color="success" @click="showEditDlg = false" width="100" outlined>キャンセル</v-btn>
                        </v-col>
                        <v-col class="text-center pa-0">
                            <v-btn color="success" @click="axiosSubmit()" width="100">登録</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- --------------------- -->
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="showDelDlg" persistent>
            <v-card>
                <v-toolbar color="indigo" dark>確認</v-toolbar>
                <v-card-title>
                    <h5>「{{ dlgSite.name }}」を削除してもよろしいですか？</h5>
                </v-card-title>
                <v-card-actions>
                    <v-btn width="100" color="error" class="float-left" @click="axiosDelete()">削除！</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn width="100" color="success" outlined @click="showDelDlg = false">キャンセル</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
    </v-container>
</template>

<script>
import Prefectures from "@/prefectures.json";
export default {
    name: "Sites",
    data() {
        return {
            jwt: "",
            myInfo: { id: 0, name: "", user_id: 0, site_id: 0 },
            showEditDlg: false,
            showDelDlg: false,
            isLoading: false,
            dbSites: [],
            dlgSite: {
                id: 0,
                name: "",
                pref_id: 0,
                pref: "",
                city: "",
            },
            optPref: [],
        };
    },
    //========================================================
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //-----------------------------------------------
        this.isLoading = true;
        //-----------------------------------------------
        //非同期でAxiosGet
        const promiseSite = this.axiosGetSites();
        //-----------------------
        //上記の終了を待つ
        await promiseSite;
        //-----------------------
        await new Promise((r) => setTimeout(r, 500));
        //-----------------------
        this.createPrefOptions();
        this.isLoading = false;
        window.scrollTo(0, 0);
        //-----------------------------------------------
    },
    //========================================================
    methods: {
        //===================================================
        createPrefOptions() {
            let prefs = Prefectures.prefectures;
            this.optPref = [];
            for (let i in prefs) {
                let code = prefs[i].code;
                let name = prefs[i].name;
                this.optPref.push({ value: code, text: name });
            }
        },
        //===================================================
        async axiosGetSites() {
            await this.axios({
                method: "GET",
                url: "/web/api/sites",
                //params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbSites = response.data.json;
            });
        },
        //===================================================
        // 変更ダイアログ表示
        //===================================================
        openDlgClick(primaryKey) {
            //-----------------------------
            if (primaryKey) {
                for (let obj of this.dbSites) {
                    if (obj.id == primaryKey) {
                        this.dlgSite = JSON.parse(JSON.stringify(obj));
                    }
                }
            } else {
                this.dlgSite["id"] = 0;
                this.dlgSite["name"] = "サイト名";
                this.dlgSite["pref_id"] = 1;
                this.dlgSite["pref"] = "";
                this.dlgSite["city"] = "";
                delete this.dlgSite["modified"];
            }
            this.showEditDlg = true;
        },
        //===================================================
        // 給餌プランDataをサブミット
        //===================================================
        async axiosSubmit() {
            let ErrCount = 0;
            if (!this.dlgSite["name"]) ErrCount++;
            if (ErrCount) {
                alert("未入力項目があります。");
                return false;
            }
            //-----------------------------------
            this.isLoading = true;
            this.showEditDlg = false;
            //-----------------------------------
            let pref_name = "";
            for (let i in this.optPref) {
                if (this.optPref[i].value == this.dlgSite.pref_id) pref_name = this.optPref[i].text;
            }
            //-----------------------------------
            const axiosData = JSON.parse(JSON.stringify(this.dlgSite));
            axiosData["site_id"] = this.myInfo.site_id;
            axiosData["pref"] = pref_name;
            delete axiosData["modified"];
            //-----------------------------------
            const primaryKey = this.dlgSite.id;
            let restMethod = "PUT";
            if (primaryKey == 0) restMethod = "POST";

            let restUrl = "/web/api/sites";
            if (primaryKey > 0) restUrl = restUrl + "/" + primaryKey;

            await this.axios({
                method: restMethod,
                url: restUrl,
                headers: { Authorization: "Bearer " + this.jwt },
                data: axiosData,
                timeout: 30000,
            })
                .then(() => {
                    this.axiosGetSites();
                })
                .catch(function (error) {
                    if (error.response.data.err == "ER_DUP_ENTRY") {
                        alert("重複しています。\n保存できません。");
                    } else {
                        alert("ん？ " + error.response.data.err);
                    }
                });
            //-----------------------------------
            await new Promise((r) => setTimeout(r, 100));
            this.isLoading = false;
        },
        //===================================================
        // 給餌プランDataをサブミット
        //===================================================
        async axiosDelete() {
            this.showDelDlg = false;
            this.showEditDlg = false;
            this.isLoading = true;
            //-------------------------
            const PrimaryKey = this.dlgSite.id;
            await this.axios({
                method: "DELETE",
                url: "/web/api/sites/" + PrimaryKey,
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then(() => {
                this.axiosGetSites();
            });
            await new Promise((r) => setTimeout(r, 100));
            this.isLoading = false;
        },
        //===================================================
    },
    //========================================================
};
</script>
